export default __webpack_public_path__ + "274885f17d5001b262e7d0e5667f447c.png";